<template>
    <div :class="colclass">
        <d-label v-if="label" :label="label"/>
        <div class="input-group">
            <input
                    :class="codclass"
                    type="text"
                    class="form-control"
                    ref="input"
                    :value="value"
                    :readonly="readonly"
                    :placeholder="placeholder"
                    @keydown="getkeydown($event)"
                    @input="updateValue($event.target.value)"
            />
            <div class="input-group-append" id="button-addon4">
                <button class="btn btn-outline-secondary" type="button" @click="openModal()" v-if="xsearch"><i class="di di-search"></i></button>
                <button v-if="follow" class="btn btn-outline-secondary" :class="followclass" type="button" @click="dofollow()">➤</button>
            </div>
        </div>
    </div>
</template>
<script>
    import {Dau, bus} from "@store/dau";

    export default {
        props: {
            label: String,
            value: String,
            cols: Number,
            placeholder: String,
            readonly: Boolean,
            small: Boolean,
            large: Boolean,
            noborder: Boolean,
            search: Object,
            table: String,
            follow: String
        },
        data() {
            return {
                ismodal: false
            };
        },
        methods: {
            openModal() {
                if (this.xsearch) {
                    this.$3cadComponent({
                        title: !this.label ? this.$parent.$parent.title : this.label,
                        size: 'xl',
                        component: 'd-search',
                        componentData: {
                            service: this.xsearch.service,
                            func: this.xsearch.func,
                            params: this.xsearch.params
                        },
                        componentEvents: ['select']
                    }).then( data =>{
                        this.updateValue(data.cod, data.des);
                    }).catch(()=>{});
                    /*this.$refs.search
                        .open({
                            title: !this.label ? this.$parent.$parent.title : this.label,
                            module: this.xsearch.service,
                            func: this.xsearch.func,
                            params: this.xsearch.params
                        })
                        .$once("close", (mode, data) => {
                            if (mode === 1) this.updateValue(data.cod, data.des);
                            return;
                        });*/
                }
            },
            loadpage(cod) {
                if (this.table == "*") return;
                if (!this.xsearch) return;
                var sc = this;
                var p = {
                    Page: 1,
                    Rows: 1,
                    cOrder: "",
                    cwhere: "0:" + cod
                };
                if (this.xsearch.params) p = Object.assign(p, this.xsearch.params);
                var func = this.xsearch.func ? this.xsearch.func : "HelperSearch";
                var service = this.xsearch.service ? this.xsearch.service : "helpers";
                var xcod = 1;
                Dau.com(service, func, p, d => {
                    if (d && d.data && d.data.records && d.data.records[0] && d.data.records[0][xcod] && (cod + "").toUpperCase() == (d.data.records[0][xcod] + "").toUpperCase()) {
                        var res = "";
                        res = d.data.records[0][xcod];
                        this.$emit("input", res);
                    }
                });
            },
            getkeydown(e) {
                var sc = this;
                switch (e.key) {
                    case "?":
                        if (this.table == "*") {
                            this.$emit("select", this.value);
                        } else {
                            this.ismodal = true;
                        }
                        e.preventDefault();
                        break;
                    case "Enter":
                        var cod = sc.value;
                        if (cod) {
                            this.loadpage(cod);
                            e.preventDefault();
                        }
                        break;
                }
            },
            updateValue(cod) {
                var sc = this;
                var res = "";
                res = cod != undefined ? cod : this.value;
                this.$emit("input", res);
            },
            load(e) {
                this.updateValue(e.cod);
                this.ismodal = false;
            },
            dofollow() {
                var sc = this;
                var x = sc.follow
                    .trim()
                    .split("#")
                    .join(sc.value);
                if (x) bus.$emit("routeadd", {cod: x});
            },
            getsize() {
                var aa = this.noborder ? " noborder" : "";
                return this.small ? aa + " small" : this.large ? aa + " large" : "";
            }
        },
        computed: {
            xsearch() {
                if (this.search) return this.search;
                if (this.table) {
                    if (this.table == "*") return this.table;
                    var x = this.table;
                    if (x.indexOf(",") > 0) {
                        return {
                            service: x.ex(",", 1),
                            func: x.ex(",", 2),
                            params: {
                                Table: x.ex(",", 3)
                            }
                        };
                    } else {
                        return {
                            params: {
                                Table: this.table
                            }
                        };
                    }
                }
            },
            codclass() {
                return "col connectright" + this.getsize();
            },
            btnclass() {
                var aa = "btn btn-info ";
                if (!this.follow) aa = aa + "connectleft";
                else aa = aa + "connect";
                return aa + this.getsize();
            },
            followclass() {
                return "btn btn-warning connectleft follow " + this.getsize();
            },
            colclass() {
                if (this.cols && Number.isInteger(this.cols) && this.cols > 0 && this.cols < 13) return "col-" + this.cols;
                else return "col";
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/_eng/globals/dcod.vue